import { useState } from "react";
import styles from "./InputNumber.module.css";

function Number({ text, value, unit, isDisabled }) {
  return (
    <form className={styles.inputNumberComponent}>
      <label className={styles.componentText}>{text} =</label>
      <input
        className={styles.componentInput}
        value={value}
        inputMode="decimal"
        disabled={isDisabled}
      ></input>
      <label className={styles.componentUnit}>{unit ? unit : ""}</label>
    </form>
  );
}

export default Number;
